// Copyright (C) 2021 Bystronic Laser AG

export enum DeviceStatusEnum {
  None = 0,
  Healthy = 1,
  Unhealthy = 2,
}
